import { RootState } from 'src/store/rootStore';
export const selectWebView = (state: RootState) => state.webview.webView;
export const selectWebViewFile = (state: RootState) => state.webview.webViewFile;
